import { useLogError } from '@/src/common/hooks/useLogError'
import { UserSurveyResponseType } from '@api/mesa/graphql'
import * as StoreReview from 'expo-store-review'
import { useEffect, useRef } from 'react'

export const Survey2025JuneFollowup = ({
  onComplete,
}: {
  onComplete: (responseType: UserSurveyResponseType) => void
}) => {
  const didPrompt = useRef(false)
  const logError = useLogError()

  useEffect(() => {
    // Only prompt once; this component will unmount after the prompt is presented and a
    // response is recorded.
    if (!didPrompt.current) {
      const prompt = async () => {
        didPrompt.current = true

        try {
          // Native Store Reviews are fire and forget. We don't get any feedback on whether it's
          // even presented or not, let alone what the user's response was.
          // The API controls how often this is presented, so we don't need to worry about
          // spamming the user or violating iOS/etc guidelines.
          if (await StoreReview.isAvailableAsync()) {
            console.log('Requesting review as the platform supports it')
            void StoreReview.requestReview()
            onComplete(UserSurveyResponseType.CompletedSurvey)
          } else {
            console.log('Dismissing survey as the platform does not support it')
            onComplete(UserSurveyResponseType.DismissedSurvey)
          }
        } catch (error) {
          logError(error)
        }
      }

      void prompt()
    }
  }, [onComplete, logError])

  return null
}
